export default __webpack_public_path__ + "static/media/Group2.e700b390.svg";